import clsx from "clsx";

import useDispatchStore from "@web-app/store/dispatchStore";

function ReportCountCell({
  data,
  value,
}: {
  data: { entity: "order" | "route"; id: string };
  value: number;
}) {
  const reportCount = value || 0;

  const handleClick = () => {
    if (data.entity === "order") {
      useDispatchStore.setState({
        selectedSidebarOrderIds: [data.id],
      });
    }
  };

  const cellStyles = clsx(
    "inline-flex items-center justify-center min-w-[24px] h-6 px-2 rounded-full text-xs font-medium cursor-pointer",
    reportCount === 0
      ? "bg-gray-100 text-gray-600"
      : "bg-red-100 text-red-800 hover:bg-red-200",
  );

  return (
    <div className="flex items-center">
      <span className={cellStyles} onClick={handleClick}>
        {reportCount}
      </span>
    </div>
  );
}

export default ReportCountCell;
